import { createContext, useContext, useState } from "react";

const AdvisorContext = createContext(null);

export function AdvisorProvider({ children }) {
  const [pending, setPending] = useState(null);

  const openAdvisorForEmployee = (employeeId, employeeName) => {
    setPending({ employeeId, employeeName, trigger: Date.now() });
  };

  const clearPending = () => setPending(null);

  return (
    <AdvisorContext.Provider value={{ pending, openAdvisorForEmployee, clearPending }}>
      {children}
    </AdvisorContext.Provider>
  );
}

export function useAdvisor() {
  return useContext(AdvisorContext);
}
